import { useEffect, useState } from "react";
import { Delete, ScanFace } from "lucide-react";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "bio", "0", "del"];

export function PinPad({ onComplete, onBiometric, showBiometric, error, disabled }) {
  const [pin, setPin] = useState("");
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (error) { setShake(true); setPin(""); const t = setTimeout(() => setShake(false), 450); return () => clearTimeout(t); }
  }, [error]);

  useEffect(() => {
    if (pin.length === 6) { const p = pin; setPin(""); onComplete(p); }
  }, [pin, onComplete]);

  useEffect(() => {
    const onKey = (e) => {
      if (disabled) return;
      if (/^\d$/.test(e.key)) setPin((p) => (p.length < 6 ? p + e.key : p));
      if (e.key === "Backspace") setPin((p) => p.slice(0, -1));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [disabled]);

  const press = (k) => {
    if (disabled) return;
    if (k === "del") return setPin((p) => p.slice(0, -1));
    if (k === "bio") return onBiometric?.();
    setPin((p) => (p.length < 6 ? p + k : p));
  };

  return (
    <div className="flex flex-col items-center gap-8 w-full">
      <div data-testid="pin-dots" className={`flex gap-4 ${shake ? "shake" : ""}`}>
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i} data-testid={`pin-dot-${i}`}
            className={`w-3.5 h-3.5 rounded-full border transition-colors ${i < pin.length ? "bg-[#d4af37] border-[#d4af37] dot-pop" : "border-muted-foreground/60"}`} />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3 w-full max-w-[300px]">
        {KEYS.map((k) => {
          if (k === "bio" && !showBiometric) return <span key={k} />;
          return (
            <button key={k} type="button" disabled={disabled} onClick={() => press(k)}
              data-testid={k === "del" ? "pin-key-delete" : k === "bio" ? "pin-key-biometric" : `pin-key-${k}`}
              className="h-[72px] rounded-full bg-secondary/80 border border-border text-2xl font-display font-light text-foreground flex items-center justify-center active:bg-accent active:scale-95 transition-[transform,background-color] disabled:opacity-40">
              {k === "del" ? <Delete size={24} /> : k === "bio" ? <ScanFace size={26} className="text-[#d4af37]" /> : k}
            </button>
          );
        })}
      </div>
    </div>
  );
}
